import { memo, useMemo } from 'react';

import { clsx } from 'clsx';

import { Checkbox } from '@shared/ui/Checkbox';
import { HStack } from '@shared/ui/Stack';

import { useCart } from '../../';
import cls from './Top.module.scss';

type TopProps = {
  selectAllValue: boolean;
  deleteDisabled: boolean;
};

export const Top = memo<TopProps>(({ deleteDisabled, selectAllValue }) => {
  const { products, selectProducts, removeProducts } = useCart();

  const selectedCartProducts = useMemo(
    () => products.reduce((acc: string[], { selected, id }) => (selected ? [...acc, id] : acc), []),
    [products]
  );

  const handleClickSelectAll = () => {
    selectProducts();
  };

  const handleClickSelectedProducts = () => {
    removeProducts(selectedCartProducts);
  };

  return (
    <HStack justify={'between'}>
      <Checkbox
        classNameLabel={cls.label}
        value={selectAllValue}
        onChange={handleClickSelectAll}
        label={'Выбрать все'}
      />
      <div
        className={clsx(cls.delete, { [cls.disabled]: deleteDisabled })}
        onClick={deleteDisabled ? undefined : handleClickSelectedProducts}
      >
        Удалить выбранные товары
      </div>
    </HStack>
  );
});
